import React from 'react';

interface RadioCardOption {
  id: string;
  name: string;
  /** Shown but not selectable, e.g. a member's current role that the caller may not hand out. */
  disabled?: boolean;
  /** Short explanation rendered under the name. */
  hint?: string;
}

interface RadioCardSelectProps {
  options: RadioCardOption[];
  value: string | null;
  onChange: (id: string) => void;
}

export function RadioCardSelect({options, value, onChange}: RadioCardSelectProps) {
  return (
    <div className="flex flex-col gap-2" role="radiogroup">
      {options.map((option) => {
        const isSelected = option.id === value;
        return (
          <button
            key={option.id}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={option.disabled}
            onClick={() => onChange(option.id)}
            className={`flex items-center gap-3 px-4 py-3 rounded-lg border-2 transition-colors text-left disabled:cursor-not-allowed ${
              isSelected
                ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-400'
                : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500'
            } ${option.disabled ? 'opacity-70' : ''}`}
          >
            <div
              className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                isSelected ? 'border-blue-500 dark:border-blue-400' : 'border-gray-300 dark:border-gray-500'
              }`}
            >
              {isSelected && <div className="w-2 h-2 rounded-full bg-blue-500 dark:bg-blue-400" />}
            </div>
            <span className="flex flex-col">
              <span className={`text-sm font-medium ${isSelected ? 'text-gray-900 dark:text-gray-100' : 'text-gray-700 dark:text-gray-300'}`}>
                {option.name}
              </span>
              {option.hint && <span className="text-xs text-gray-500 dark:text-gray-400">{option.hint}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}
